import React, { Fragment, useEffect, useState, useCallback } from "react"
import { useParams } from "react-router-dom"
import _ from "lodash"
import { Asterisk, Globe, User, CircleUser } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { findById, updateById } from "lib/utils/apiHelpers"
import { GridTableButton, LayoutBuilder, Tabset, TagsManager } from "lib/components"
import { Forms } from "lib/components/forms"

export default function Layout({ id=null }: { id?:string|null }){

  const { layid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const [ layout, setLayout ] = useState<any>()

  // const { data:layout } = queryTools.resource.parseQueryForApi("layout.findById", { _id: lookupId }, { enabled: lookupId === id })
  // const saveMethod = queryTools.resource.save(["layout.all"])

  const getLayout = async(id:string) => await findById({ resource: "layout", idObj: { key: "_id", value: id } })
  const updateLayout = async(id:string, data:any) => await updateById({ resource: "layout", idObj: { key: "_id", value: id }, data })

  const handleInputChange = (e:any) => setLayout({ ...layout, [e.target.name]: e.target.value })


  const saveLayout = () => {
    // saveMethod.mutate({ resource: "layout", data: layout._id } )
  }

  useEffect(() => {
    if( layid ){
      getLayout(layid).then((layoutObj:any) => {
        console.log(layoutObj)
        if( layoutObj ){
          const { _id, name, description, funfact, config } = layoutObj
          setLayout({ _id, name, description, funfact, config })
        }
      })
    }
  },[layid])


  if( !layout ) return <></>
  return(
    <div className="w-full h-full border border-solid border-slate-700 p-[2px]">
      <div className="w-full h-6 pl-4 pr-2 h-8 flex items-center bg-slate-700 text-white text-sm uppercase">Edit Layout: { layout?.name }</div>
      <div className="w-full flex flex-col px-4 py-2">

        <Tabset tabs={["basics", "structure"]}>
          
          <div id="basics">
            <div className="w-full flex gap-3">
              <Forms.Form className="w-7/12 flex flex-col">
                <Forms.FieldGroup label="Layout Name" className="w-full">
                  <Forms.InputField 
                    type="text" 
                    name="name" 
                    value={layout.name} 
                    onChange={handleInputChange}  
                  />
                </Forms.FieldGroup>

                <Forms.FieldGroup label="Description" className="w-full">
                  <Forms.Textarea 
                    name="description" 
                    value={layout.description} 
                    onChange={handleInputChange}  
                  />
                </Forms.FieldGroup>

                <Forms.FieldGroup label="Fun Fact" className="w-full">
                  <Forms.Textarea 
                    name="funfact" 
                    className="h-36"
                    value={layout.funfact} 
                    onChange={handleInputChange}  
                  />
                </Forms.FieldGroup>
              </Forms.Form>
            </div>

            <div className="w-full flex justify-center items-center mt-3">
              <button 
                className="w-full px-3 py-1 text-sm border border-solid border-teal-700 bg-teal-800 hover:bg-teal-900" 
                onClick={saveLayout}
              >
                Save
              </button>
            </div>
          </div>


          { layout !== undefined && (
            <div id="structure">
              <LayoutBuilder layout={layout} />
            </div>
          )}

        </Tabset>

      </div>
    </div>
  )
}